export default "__VITE_ASSET__CFhhZcCh__"